var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { position: "relative" },
      on: {
        click: function($event) {
          _vm.isShowingUserInfoBoard = true
        }
      }
    },
    [
      _c(
        "svg",
        {
          staticClass: "screenfull-svg",
          attrs: {
            t: "1508738709248",
            viewBox: "0 0 128 128",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "p-id": "2069",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            width: "128px",
            height: "128px"
          },
          on: { click: _vm.click }
        },
        [
          _c("g", { attrs: { id: "图层_2" } }, [
            _c("g", [
              _c("path", {
                attrs: {
                  fill: "#2F3133",
                  d:
                    "M103.859,81.787c-2.409-1.991-4.82-3.75-7.45-5.391c-5.15-3.164-10.63-5.506-16.438-7.146\n\t\t\tc10.959-6.093,18.411-18.397,18.411-32.458C98.382,16.522,82.932,0,63.972,0C45.014,0,29.563,16.404,29.563,36.793\n\t\t\tc0,14.061,7.452,26.365,18.41,32.574C24.302,75.813,5.235,96.2,0.084,122.447c-0.438,2.227,0.877,4.335,2.959,4.804\n\t\t\tc0.219,0.117,0.548,0.117,0.767,0.117c1.753,0,3.397-1.287,3.726-3.281c5.589-28.239,29.259-48.862,56.327-48.862\n\t\t\tc10.083,0,19.946,2.813,28.711,8.205c2.301,1.405,4.492,3.045,6.574,4.687c1.644,1.405,4.055,1.054,5.369-0.704\n\t\t\tC105.833,85.771,105.613,83.193,103.859,81.787L103.859,81.787z M37.233,36.793c0-15.819,12.055-28.591,26.738-28.591\n\t\t\tc14.685,0,26.739,12.772,26.739,28.591c0,15.818-12.056,28.59-26.739,28.59S37.233,52.495,37.233,36.793L37.233,36.793z"
                }
              }),
              _c("path", {
                attrs: {
                  fill: "#409EFF",
                  d:
                    "M107.479,95.848c0,2.461,1.864,4.454,4.164,4.454c2.299,0,4.164-1.993,4.164-4.454\n\t\t\tc0-2.457-1.865-4.451-4.164-4.451C109.343,91.396,107.479,93.391,107.479,95.848L107.479,95.848z"
                }
              }),
              _c("path", {
                attrs: {
                  fill: "#409EFF",
                  d:
                    "M115.258,108.621c0,2.459,1.864,4.452,4.164,4.452c2.301,0,4.164-1.993,4.164-4.452\n\t\t\tc0-2.46-1.863-4.453-4.164-4.453C117.122,104.168,115.258,106.161,115.258,108.621z"
                }
              }),
              _c("path", {
                attrs: {
                  fill: "#409EFF",
                  d:
                    "M119.422,122.8c0,2.458,1.864,4.451,4.164,4.451c2.301,0,4.164-1.993,4.164-4.451\n\t\t\tc0-2.46-1.863-4.454-4.164-4.454C121.286,118.346,119.422,120.34,119.422,122.8z"
                }
              })
            ])
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowingUserInfoBoard,
              expression: "isShowingUserInfoBoard"
            }
          ],
          staticStyle: {
            position: "fixed",
            right: "50px",
            "z-index": "99999",
            "min-width": "240px",
            "min-height": "270px",
            border: "1px solid #e1e1e1",
            "background-color": "white",
            "font-size": "13px",
            display: "flex"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                top: "4px",
                right: "4px",
                cursor: "pointer"
              },
              on: { click: _vm.dismissUserInfoBoard }
            },
            [
              _c("i", {
                staticClass: "el-icon-close",
                staticStyle: { "font-size": "20px" }
              })
            ]
          ),
          _c(
            "div",
            {
              staticStyle: {
                "border-left": "1px solid #e1e1e1",
                padding: "15px"
              }
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "30px", display: "flex" } },
                  [
                    _c("span", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v(_vm._s(_vm.userInfo.chineseName))
                    ])
                  ]
                )
              ]),
              _c(
                "div",
                { staticStyle: { "margin-top": "16px", display: "flex" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "font-weight": "bold",
                        width: "40px",
                        "margin-left": "4px"
                      }
                    },
                    [_vm._v("用户:")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "margin-left": "26px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.userInfo.userName))]
                  )
                ]
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "16px", display: "flex" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "font-weight": "bold",
                        width: "40px",
                        "margin-left": "4px"
                      }
                    },
                    [_vm._v("部门:")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "margin-left": "26px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.userInfo.departmentName))]
                  )
                ]
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "16px", display: "flex" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "font-weight": "bold",
                        width: "40px",
                        "margin-left": "4px"
                      }
                    },
                    [_vm._v("公司:")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "margin-left": "26px",
                        "min-width": "170px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.userInfo.officeName))]
                  )
                ]
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "16px", display: "flex" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "font-weight": "bold",
                        width: "40px",
                        "margin-left": "4px"
                      }
                    },
                    [_vm._v("电话:")]
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "26px" } },
                    [
                      _vm.mobileInputVisible
                        ? [
                            _c("el-input", {
                              ref: "mobileInput",
                              attrs: { size: "mini" },
                              on: { blur: _vm.editMobileDo },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.editMobileDo($event)
                                }
                              },
                              model: {
                                value: _vm.mobileNew,
                                callback: function($$v) {
                                  _vm.mobileNew = $$v
                                },
                                expression: "mobileNew"
                              }
                            })
                          ]
                        : [
                            _c(
                              "span",
                              { staticStyle: { "font-size": "12px" } },
                              [_vm._v(_vm._s(_vm.userInfo.mobile))]
                            )
                          ],
                      !_vm.mobileInputVisible
                        ? _c(
                            "span",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: { click: _vm.toEditMobile }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-edit",
                                staticStyle: { color: "#46a6ff" }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "16px", display: "flex" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "font-weight": "bold",
                        width: "40px",
                        "margin-left": "4px"
                      }
                    },
                    [_vm._v("邮箱:")]
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "26px" } },
                    [
                      _vm.emailInputVisible
                        ? [
                            _c("el-input", {
                              ref: "emailInput",
                              attrs: { size: "mini" },
                              on: { blur: _vm.editEmailDo },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.editEmailDo($event)
                                }
                              },
                              model: {
                                value: _vm.emailNew,
                                callback: function($$v) {
                                  _vm.emailNew = $$v
                                },
                                expression: "emailNew"
                              }
                            })
                          ]
                        : [
                            _c(
                              "span",
                              { staticStyle: { "font-size": "12px" } },
                              [_vm._v(_vm._s(_vm.userInfo.email))]
                            )
                          ],
                      !_vm.emailInputVisible
                        ? _c(
                            "span",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: { click: _vm.toEditEmail }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-edit",
                                staticStyle: { color: "#46a6ff" }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "margin-top": "18px"
                  }
                },
                [
                  _c(
                    "div",
                    {},
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              return _vm.$emit(
                                "change-password-from-user-info-because-of-shit"
                              )
                            }
                          }
                        },
                        [_vm._v("修改密码")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "10px" } },
                    [
                      _c(
                        "el-button",
                        { attrs: { type: "primary", size: "mini" } },
                        [_vm._v("查看更多")]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("img", {
        staticStyle: { width: "70px", height: "70px" },
        attrs: { src: "/static/avatar.svg" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }